<template>
    <span v-if="feedShareId">
        <b-button
            class="align-baseline"
            title="Resync"
            variant="link"
            @click="handleResyncProperty"
        >
            <font-awesome-icon :icon="['fas', 'arrows-rotate']"></font-awesome-icon>
        </b-button>
    </span>
</template>

<script>
export default {
    data() {
        return { feedShareId: 0 };
    },
    created() {
        this.feedShareId = this.params.data && this.params.data.id;
    },
    methods: {
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        handleResyncProperty() {
            this.params.resync && this.params.resync({ feedShare: this.params.data, node: this.params.node });
        },
    },
};
</script>
